export const readImage = (file) => {
  const url = window.URL
    ? window.URL.createObjectURL(file)
    : window.webkitURL.createObjectURL(file);
  return url;
};
